// extracted by mini-css-extract-plugin
module.exports = {"label":"form_label__2PX5j"};